import {defaultKeyMap} from "~common/components/app-view/key-mapping-default";
import {merge} from "lodash";

const clientKeyMap = {
    "ctrl+shirt+r": [
        {
            action: "General.rickRoll",
            description: "Rick Roll" 
        }
    ],
    "ctrl+alt+r": [
        {
            action: "General.rickRoll",
            description: "Rick Roll" 
        }
    ]
}

const keyMap = merge(defaultKeyMap, clientKeyMap) 

export {keyMap as keyMap};
